import ClearIcon from '@mui/icons-material/Clear';
import { Box, MenuItem, styled, SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const HoverOverlay = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
  transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1)',
}));

export const ClearIconWrapper = styled(Box)({
  position: 'absolute',
  right: 24,
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

export const StyledClearIcon = styled(ClearIcon)(({ theme: { palette } }) => ({
  fontSize: 20,
  color: palette.action.active,
  cursor: 'pointer',
  '&:hover': {
    color: palette.text.primary,
  },
}));

export const displayLabelStyles: SxProps<Theme> = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  maxWidth: 120,
};

export const checkboxStyles: SxProps<Theme> = {
  padding: '5px',
};

export const createFilterWrapper = (variant?: 'default' | 'fixed-height') =>
  styled(Box)(({ theme: { shape, sass } }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderRadius: shape.borderRadius,
    overflow: 'hidden',
    cursor: 'pointer',
    ...(variant === 'fixed-height' && { height: 36 }),
    '&:hover .hover-overlay': {
      backgroundColor: alpha(sass.globalAccentColor, 0.1),
    },
  }));

export const BaseStyledMenuItem = styled(MenuItem)<{ selected: boolean }>(({ theme, selected }) => ({
  borderLeft: '3px solid',
  borderColor: selected ? theme.palette.primary.main : 'transparent',
}));

export const getSelectStyles = (hasValue: boolean, defaultPadding: string | number = 32): SxProps<Theme> => ({
  color: hasValue ? 'primary.main' : 'text.primary',
  '& .MuiSelect-standard': {
    paddingRight: hasValue ? '48px !important' : defaultPadding,
  },
});
